<template>
  <div
    class="relative overflow-hidden"
    :style="`height: ${containerHeight}; width: ${width};`"
  >
    <slot name="before-map"></slot>

    <div id="google-map-area"></div>

    <slot name="after-map"></slot>
  </div>
</template>

<script>
import googleMapsInit from "../gmaps";

export default {
  props: {
    containerHeight: {
      type: String,
      default: "300px",
    },
    height: {
      type: String,
      default: "300px",
    },
    width: {
      type: String,
      default: "100%",
    },
    options: {
      type: Object,
      default: () => {},
    },
    center: {
      type: Object,
    },
    zoom: {
      type: Number,
      default: 6,
    },
    markerOptions: {
      type: Object,
      default: () => {},
    },
    markerIconOptions: {
      type: Object,
      default: () => {},
    },
    addMarkerToCenter: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      google: null,
      marker: null,
      map: null,
      mapElement: null,
      defaultLocation: {
        address: "US",
      },
      defaultOptions: {
        panControl: true,
        zoomControl: true,
        mapTypeControl: false,
        scaleControl: true,
        streetViewControl: false,
        overviewMapControl: true,
        rotateControl: true,
      },
    };
  },

  async mounted() {
    let vm = this;
    this.mapElement = document.getElementById("google-map-area");

    try {
      this.google = await googleMapsInit();
      this.map = new this.google.maps.Map(this.mapElement, {
        ...this.defaultOptions,
        ...this.options,
        zoom: this.zoom,
      });

      this.map.addListener("click", () => {
        this.$emit("showEditMapModal");
      });

      this.$nextTick(() => {
        if (window.gmapsCallback) {
          vm.setupMap();
        }
      });
    } catch (error) {
      console.log("There was an error initializing the map: ", error);
    }
  },

  methods: {
    setupMap() {
      let vm = this;

      this.mapElement.style.width = this.width;
      this.mapElement.style.height = this.height;
      setTimeout(function () {
        vm.setMapCenter();
      }, 500);
      this.$emit("mapReady", this.map, this.google);
    },

    setMapCenter() {
      this.clearMarker();

      if (!this.center || !this.google) {
        this.setMapToDefaultLocation();
        return;
      }

      let point = new this.google.maps.LatLng(this.center.lat, this.center.lng);

      this.map.setCenter(point);

      if (!this.addMarkerToCenter) return;

      let marker = new this.google.maps.Marker({
        position: point,
        ...this.markerOptions,
      });

      if (Object.keys(this.markerIconOptions).length) {
        let { size, ...remainingIconProps } = this.markerIconOptions;

        size = size ?? 30;
        marker.setIcon({
          ...remainingIconProps,
          scaledSize: new this.google.maps.Size(size, size),
        });
      }

      marker.setMap(this.map);

      this.marker = marker;
    },

    setMapToDefaultLocation() {
      let geocoder = new this.google.maps.Geocoder();

      geocoder.geocode(this.defaultLocation, (results, status) => {
        if (status !== "OK" || !results[0]) {
          throw new Error(status);
        }

        this.map.setCenter(results[0].geometry.location);
        this.map.fitBounds(results[0].geometry.viewport);
        this.map.setZoom(this.zoom);
      });
    },

    clearMarker: function () {
      // Clear out the old markers.
      if (this.marker) {
        this.marker.setMap(null);
      }

      this.marker = null;
    },
  },
  watch: {
    center: {
      handler: function () {
        this.setupMap();
      },
      deep: true,
    },
  },
};
</script>

<style>
.cluster > *:focus {
  outline: none;
}

.gm-style .gm-style-iw-c {
  border-radius: 5px;
  padding: 15px;
}
</style>
